export default {
  'button-checkout': 'Passer au paiement',
  'button-skipstep': 'Non, merci',
  'button-continue': 'Continuer',
};
